import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {AddArtistsToTagModel} from '../../models/add-artists-to-tag.model';
import {FormControl} from "@angular/forms";
import {UserTagModel} from "../../models/user-tag.model";
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-add-artists',
  templateUrl: './add-artists.component.html',
  styleUrls: ['./add-artists.component.css']
})
export class AddArtistsComponent implements OnInit {
  artists: AddArtistsToTagModel[];
  artistsFiltered: AddArtistsToTagModel[];
  @Input() tagToFilterOn: UserTagModel;
  @Output() addArtistsEvent = new EventEmitter<any>();
  artistFilter = new FormControl('');
  loading$ = this.loadingService.loading$;

  constructor(private spotifyTagsService: SpotifyTagsService,private loadingService: LoadingService) {}

  ngOnInit() {
    this.spotifyTagsService.getArtistsByTag(this.tagToFilterOn).subscribe(response => {
      this.artists = response;
      this.artistsFiltered = response;
      this.artistFilter.valueChanges.subscribe(value => {
        if (!value) {
          this.artistsFiltered = this.artists;
        } else {
          this.artistsFiltered = this.artists.filter(artist => artist.name.toLowerCase().includes(value.toLowerCase()))
        }
      });
    });
  }

  selectTag(artist: AddArtistsToTagModel) {
    artist.hasTag = !artist.hasTag;
  }

  submit() {
    this.spotifyTagsService.addArtistsToTag(this.tagToFilterOn, this.artists).subscribe(() => {
      this.addArtistsEvent.emit();
    });
  }

  cancel() {
    this.addArtistsEvent.emit();
  }
}
